import { EXPERIENCE_API_VERSION } from '../app.config'

export const getResultsIndexExperienceParams = (
  timezone?: string,
  navId?: string,
  isInEventHubBracketsVariation?: boolean
) => {
  return {
    version: EXPERIENCE_API_VERSION,
    limit: '100',
    offset: '0',
    tz: timezone || 'America/Los_Angeles',
    ...(!!navId && { nav_id: navId }),
    isEventHubLayoutEnabled: 'true',
    ...(!!isInEventHubBracketsVariation && { isEventHubBracketsEnabled: isInEventHubBracketsVariation.toString() })
  }
}
